class SessionStorage {
  /**
   * Set a value in sessionStorage.
   * @param {string} key - Key to set.
   * @param {any} value - Value to set.
   */
  static set(key, value) {
    sessionStorage.setItem(key, value);
  }

  static setStringify(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Get a value from sessionStorage.
   * @param {string} key - Key to retrieve.
   * @returns {any} Retrieved value.
   */
  static get(key) {
    return sessionStorage.getItem(key);
  }

  /**
   * Remove a value from sessionStorage.
   * @param {string} key - Key of the item to remove.
   */
  static remove(key) {
    sessionStorage.removeItem(key);
  }

  /**
   * Remove all items from sessionStorage.
   */
  static clear() {
    sessionStorage.clear();
  }
}

export default SessionStorage;
